import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface ResendOnboardingEmailParams {
  parentId: string;
}

export const resendOnboardingEmail = async (
  params: ResendOnboardingEmailParams,
) => {
  const response = await baseAPI.post<unknown>(
    `/parents/${params.parentId}/reset-temporary-password`,
    {},
  );

  return response.data;
};

export const useResendOnboardingEmailMutation = () => {
  return useMutation({
    mutationFn: resendOnboardingEmail,
  });
};
